/**
 * Pure Mux playback URL builders. NO secret key required and NO `server-only`
 * guard, so these are safe to import from Client Components (the player) as well
 * as Server Components. src/lib/portfolio/mux.ts re-exports them so server code
 * has a single import surface.
 */

/** HLS stream URL for a Mux playback id. */
export function muxStreamUrl(playbackId: string): string {
  return `https://stream.mux.com/${playbackId}.m3u8`;
}

/** Poster/thumbnail URL for a Mux playback id. */
export function muxThumbnailUrl(
  playbackId: string,
  opts: { time?: number; width?: number } = {},
): string {
  const params = new URLSearchParams();
  if (opts.time != null) params.set("time", String(opts.time));
  if (opts.width != null) params.set("width", String(opts.width));
  const qs = params.toString();
  return `https://image.mux.com/${playbackId}/thumbnail.jpg${qs ? `?${qs}` : ""}`;
}
